import { applicationsQuery } from '../api/opteemum'
import { ApplicationTabs } from '../softsee/ApplicationsPage'
import { applicationColumns } from './columns'
import { OpteemumTablePage } from './TablePage'

/**
 * Opteemum::applications - `#softseeApplications`.
 *
 * Randul se DESFACE. Coloana intai deseneaza de la bun inceput semnul de plus
 * (`show_details`), ca in macheta veche, dar pana acum nu era nimic dedesubt:
 * omul apasa si nu se intampla nimic. Filele sunt aceleasi patru din
 * `applications/actionsTabs.php` - Summary, Devices, Uninstall, Update - si
 * sunt ACELEASI cu ale listei din Softsee, fiindca e aceeasi lista pe alta usa.
 * Citirile vin de pe usa Opteemum, ca sa se ceara dreptul cu care s-a deschis
 * lista.
 */
export function ApplicationsPage() {
  return (
    <OpteemumTablePage
      id="softseeApplications"
      columns={applicationColumns()}
      queryOf={applicationsQuery}
      details={(row) => <ApplicationTabs id={Number(row.ID)} door="opteemum" />}
      rowKey={(r) => Number(r.ID)}
    />
  )
}
